import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import dayjs from 'dayjs';

export interface StatusProps {
	testStart: string;
	testEnd: string;
}

const TestStatus = styled.div`
	padding: 5px 16px;
	font-weight: bold;
	font-size: 14px;
	line-height: 20px;
	color: rgba(9, 21, 38, 0.6);
`;

const EmptyState = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 888px;
	height: 508px;
	font-size: 16px;
	line-height: 22px;
	text-align: center;
	color: rgba(9, 21, 38, 0.6);
	border: 1px solid rgba(9, 21, 38, 0.15);
`;

const TestPlanned = styled(TestStatus)`
	background: rgba(238, 239, 240, 0.6);
`;

const TestStarted = styled(TestStatus)`
	background: rgba(224, 245, 251, 0.6);
`;

const TestFinished = styled(TestStatus)`
	background: rgba(111, 207, 151, 0.6);
`;

const dateFormat = 'D MMMM YYYY';

const Component = ({ testStart, testEnd, children }: PropsWithChildren<StatusProps>) => {
	const now = dayjs();
	const startDate = dayjs(testStart);
	const endDate = dayjs(testEnd);

	const testingIsInProgress = now.isAfter(startDate) && now.isBefore(endDate);
	const testingHasFinished = now.isAfter(endDate);
	const startDateFormatted = startDate.format(dateFormat);
	const endDateFormatted = endDate.format(dateFormat);

	return testingHasFinished || testingIsInProgress ? (
		<>
			{testingIsInProgress ? (
				<TestStarted>Тестирование началось и продлится до {endDateFormatted}</TestStarted>
			) : (
				<TestFinished>Тестирование завершено</TestFinished>
			)}
			{children}
		</>
	) : (
		<>
			<TestPlanned>
				Тестирование запланировано с {startDateFormatted} по {endDateFormatted}
			</TestPlanned>
			<EmptyState>
				Данные по тестированию начнут поступать
				<br /> после {startDateFormatted}
			</EmptyState>
		</>
	);
};

export default Component;
